import { buildService } from './decorated-service';

const beneficiariesApi = buildService('/nasu-svc/service/beneficiaries');

export const getExistingBeneficaries = (): Promise<any> =>
  beneficiariesApi.http.get('/unique');

export default beneficiariesApi;
